import React, { useEffect, useState } from "react";
import DialogBox from "../../atoms/DiaglogBox";
import toast from "react-hot-toast";
import { fetchDepositBankDetails } from "../../../utils/API/fetchDepositeBankDetails";
import { useDispatch } from "react-redux";
import Button from "../../atoms/Button";

const DepositeBankDetails = ({ open, onCancel, addMoney }) => {
  const [depositAccountDetails, setDepositAccountDetails] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const response = await fetchDepositBankDetails(dispatch);
        // console.log("API Response:", response);
        if (response && response.account_owner_name) {
          setDepositAccountDetails(response);
          // console.log("Account Details:", response);
        } else {
          // console.log("No bank details found");
          toast.error("No bank details found");
        }
      } catch (error) {
        toast.error("Failed to fetch bank details: " + error.message);
      }
    };

    if (open) {
      fetchBankDetails();
    }
  }, [open, dispatch]);

  return (
    <div>
      <DialogBox width={630} open={open} onCancel={onCancel}>
        <div className="mx-4 py-4">
          <h3 className="mx-4 font-bold text-xl my-2">Deposit</h3>
          <hr />
          <p className="text-xs text-grey-700 pl-4 pr-16 my-5">
            Deposit to the account mentioned below and share the screenshot in
            the transaction History section.
          </p>
          <p className="mx-4 my-3 font-bold text-xl">Bank Details</p>
          {depositAccountDetails ? (
            <div>
              <table className="mt-2 text-sm mx-4">
                <tbody>
                  <tr>
                    <td className="font-normal">Account Owner</td>
                    <td className="px-2">-</td>
                    <td className="capitalize">
                      {depositAccountDetails.account_owner_name}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-normal">Account no</td>
                    <td className="px-2">-</td>
                    <td>{depositAccountDetails.account_no}</td>
                  </tr>
                  <tr>
                    <td className="font-normal">Bank</td>
                    <td className="px-2">-</td>
                    <td className="capitalize">
                      {depositAccountDetails.bank_name}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-normal">Location</td>
                    <td className="px-2">-</td>
                    <td className="capitalize">
                      {depositAccountDetails.bank_address}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-normal">Account Type</td>
                    <td className="px-2">-</td>
                    <td className="capitalize">
                      {depositAccountDetails.account_type}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-normal">IFSC Code</td>
                    <td className="px-2">-</td>
                    <td>{depositAccountDetails.IFSC_code}</td>
                  </tr>
                  <tr>
                    <td className="font-normal">Swift Code</td>
                    <td className="px-2">-</td>
                    <td>{depositAccountDetails.swift_code}</td>
                  </tr>
                  <tr>
                    <td className="font-normal">MICR Code</td>
                    <td className="px-2">-</td>
                    <td>{depositAccountDetails.MICR_code}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <p className="mx-6 my-3 text-sm">Loading bank details...</p>
          )}
          <div className="mx-4">
            <Button
              color={"blue"}
              varient={"secondary"}
              className={"text-white w-full py-2 text-lg rounded-xl my-4"}
              onClick={() => {
                addMoney();
                onCancel(); 
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </DialogBox>
    </div>
  );
};

export default DepositeBankDetails;
